import * as Types from '../constants/actionTypes';
const defaultState = {
    isPending: false,
    portalCategoryList: [],
    error: ''
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case Types.PORTAL_CATEGORIES_LIST_SUCCESS:
            return {
                ...state,
                portalCategoryList: action.payload
            }
        case Types.PORTAL_CATEGORIES_ERROR:
            return {
                ...state,
                portalCategoryError: action.portalCategoryError
            }
        case Types.PORTAL_CATEGORIES_COUNT_SUCCESS:
            return Object.assign({}, state, { countPortalCategories: action.payload})
        default:
            return state
    }
}
